/**
 * External Dependencies
 */
import React, { Component, useEffect, useState } from 'react';
import { TowerProvider, Stack, Heading, Box } from '@towersystems/towersystems-design-system';

/**
 * Internal Dependencies
 */
import cscom from 'lib/customer-site-api';
import Preloader from 'components/preloader';
import Card from 'components/card';
import Icon from 'components/icon';
import logoWhite from 'assets/images/tower_logo_white.png';

const BILLING_PROFILE_NOT_FOUND = 'billing_profile_not_found';

const JwtLogin = (props) => {
    const [billingProfileError, setBillingProfileError] = useState(null);

    useEffect(() => {
        cscom
            .authentication()
            .jwtLogin(props.jwt)
            .then(({ token }) => {
                localStorage.setItem('currentUserJWT', token);
                window.location = '/dashboard';
            })
            .catch((error) => {
                const body = error && error.response && error.response.body;

                if (body && body.error === BILLING_PROFILE_NOT_FOUND) {
                    // Drop the token from the address bar now that the sign-in
                    // attempt is done — no reason to leave it sitting in the
                    // URL/history while this error page is shown.
                    window.history.replaceState(null, '', '/jwt-login');
                    setBillingProfileError(body);
                    return;
                }

                window.location = '/login';
            });
    }, []);

    if (billingProfileError) {
        return (
            <TowerProvider>
                <Box
                    display='flex'
                    flexDirection='column'
                    alignItems='center'
                    justifyContent='center'
                    style={{ height: '100%', minHeight: '100vh', gap: 24 }}
                >
                    <a href='https://www.towersystems.com.au'>
                        <img
                            src={logoWhite}
                            alt='Tower Systems'
                            style={{ width: 65, height: 'auto', filter: 'invert(1)' }}
                        />
                    </a>
                    <Card shadow padding='xxlarge' style={{ maxWidth: 420, textAlign: 'center' }}>
                        <Stack space='medium'>
                            <Box
                                display='flex'
                                alignItems='center'
                                justifyContent='center'
                                style={{
                                    width: 64,
                                    height: 64,
                                    margin: '0 auto',
                                    borderRadius: '50%',
                                    backgroundColor: 'rgba(224, 49, 49, 0.1)',
                                }}
                            >
                                <Icon type='fi' name='FiAlertTriangle' size='28' style={{ color: '#e03131' }} />
                            </Box>
                            <Heading level='2' style={{ marginBottom: 12 }}>We could not find your billing profile</Heading>
                            {/* message is a fixed string from our own backend, not user input */}
                            <p dangerouslySetInnerHTML={{ __html: billingProfileError.message }} />
                        </Stack>
                    </Card>
                    <Box style={{ fontSize: 12, color: 'rgba(0, 0, 0, 0.45)' }}>
                        &copy; {new Date().getFullYear()}{' '}
                        <a href='https://www.towersystems.com.au' style={{ color: 'inherit' }}>
                            Tower Systems Pty Ltd
                        </a>
                    </Box>
                </Box>
            </TowerProvider>
        );
    }

    return <Preloader />;
};

export default JwtLogin;
